<section class="seller-container">
  <section class="ids-mv-4">
    <form [formGroup]="formStepThree" autocomplete="off">
      <section class="ids-pt-4">
        <h2 class="ids-text-title-01">dados para pagamento</h2>
        <p class="ids-pv-4">Informe onde quer receber o valor financiado</p>

        <section class="ids-row ids-mt-4">
          <h2 class="ids-col-12 ids-text-section-02">sua conta</h2>

          <ids-form-field
            label="nome completo"
            class="ids-col-6"
            [errorMessage]="getErrorMandatory('nome completo')"
          >
            <input idsInput disabled [value]="dataPersonal.name"/>
          </ids-form-field>

          <ids-form-field label="CPF" class="ids-col-6" [errorMessage]="getErrorMandatory('CPF')">
            <input idsInput disabled [value]="dataPersonal.documentNumber"/>
          </ids-form-field>

          <ids-form-field
            label="número do banco"
            class="ids-col-6"
            [errorMessage]="getErrorMandatory('número do banco')"
          >
            <ids-select class="ids-mt-2" formControlName="payment_bankNumber" required>
              <ids-option
                *ngFor="let option of listaBancos"
                [value]="option.optValue"
              >
                {{ option.optLabel }}
              </ids-option>
            </ids-select>
          </ids-form-field>

          <ids-form-field
            label="tipo de conta"
            class="ids-col-6"
            [errorMessage]="getErrorMandatory('tipo de conta ')"
          >
            <ids-select class="ids-mt-2" formControlName="payment_accountType" required>
              <ids-option
                *ngFor="let option of tipoConta"
                [value]="option.optValue"
              >
                {{ option.optLabel }}
              </ids-option>
            </ids-select>
          </ids-form-field>

          <ids-form-field
            label="agência"
            class="ids-col-6"
            [errorMessage]="getErrorInvalid('agência')"
          >
            <input
              idsInput
              (blur)="formatAgency($event, false)"
              formControlName="payment_agencyNumber"
              required
            />
          </ids-form-field>

          <ids-form-field
            label="conta"
            class="ids-col-6"
            [errorMessage]="getErrorInvalid('conta')"
          >
            <input
              idsInput
              formControlName="payment_accountNumber"
              (input)="formatBankAccount($event, false)"
              max="30"
              required
            />
          </ids-form-field>
        </section>

        <section class="ids-row" *ngIf="isSpouseParticipates() && dataPersonal.partner">
          <h2 class="ids-col-12 ids-pt-10 ids-text-section-02">conta do cônjuge ou companheiro</h2>

          <ids-form-field
            label="nome completo"
            class="ids-col-6"
            [errorMessage]="getErrorMandatory('nome completo')"
          >
            <input idsInput disabled [value]="dataPersonal.partner.name"/>
          </ids-form-field>

          <ids-form-field label="CPF" class="ids-col-6" [errorMessage]="getErrorMandatory('CPF')">
            <input idsInput disabled [value]="dataPersonal.partner.cpf"/>
          </ids-form-field>

          <ids-form-field
            label="número do banco"
            class="ids-col-6"
            [errorMessage]="getErrorMandatory('número do banco')"
          >
            <ids-select class="ids-mt-2" formControlName="partner_payment_bankNumber" required>
              <ids-option
                *ngFor="let option of listaBancos"
                [value]="option.optValue"
              >
                {{ option.optLabel }}
              </ids-option>
            </ids-select>
          </ids-form-field>

          <ids-form-field
            label="tipo de conta"
            class="ids-col-6"
            [errorMessage]="getErrorMandatory('tipo de conta ')"
          >
            <ids-select class="ids-mt-2" formControlName="partner_payment_accountType" required>
              <ids-option
                *ngFor="let option of tipoConta"
                [value]="option.optValue"
              >
                {{ option.optLabel }}
              </ids-option>
            </ids-select>
          </ids-form-field>

          <ids-form-field
            label="agência"
            class="ids-col-6"
            [errorMessage]="getErrorInvalid('agência')"
          >
            <input
              idsInput
              oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
              (blur)="formatAgency($event, true)"
              formControlName="partner_payment_agencyNumber"
              required
            />
          </ids-form-field>

          <ids-form-field
            label="conta"
            class="ids-col-6"
            [errorMessage]="getErrorInvalid('conta')"
          >
            <input
              idsInput
              formControlName="partner_payment_accountNumber"
              (input)="formatBankAccount($event, true)"
              required
            />
          </ids-form-field>
        </section>
      </section>
    </form>
  </section>
</section>
